import React from "react";

// Renders 5 stars, filled up to the rounded rating
const Stars = ({ rating }) => {
  const filled = Math.round(rating);
  const stars = "★★★★★".slice(0, filled) + "☆☆☆☆☆".slice(0, 5 - filled);
  return (
    <span className="inline-flex items-center gap-2 text-xs">
      <span className="cp-stars">{stars}</span>
      <span style={{ color: "var(--cp-muted)" }}>{rating}/5</span>
    </span>
  );
};

export default Stars;
